/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { FunctionComponent, useEffect } from 'react';

import { AppUtils } from '../../../../core/AppUtils';
import { CursorManager } from '../../../../core/navigation';
import {
    RootState,
    useTivoDispatch,
    useTivoSelector,
} from '../../../../core/tivo/tivo-redux-wrapper';
import { disableGhostModeFilteredGuide } from '../../../../store/guide/filteredguide/filteredguide.reducers';
import { Highlight } from '../../../Highlight';

interface FilteredGuideHighlightProps {
    id?: string;
    cellType?: string;
}

export const FilteredGuideHighlight: FunctionComponent<FilteredGuideHighlightProps> = ({
    id,
    cellType,
}): JSX.Element => {
    const { verticalPosition, horizontalPosition, ghostMode } = useTivoSelector(
        (state: RootState) => state.filteredGuide,
    );

    const { isOverlayDialogActive: isAnyGuideOverlayVisible } = useTivoSelector(
        (state: RootState) => state.overlayDialog,
    );

    const { isSpinnerActive } = useTivoSelector((state: RootState) => state.spinner);

    const dispatch = useTivoDispatch();
    const isCursorAppeared = CursorManager.isCursorAppeared();

    useEffect(() => {
        if (!isCursorAppeared && ghostMode) {
            dispatch(disableGhostModeFilteredGuide());
        }
    }, [isCursorAppeared, ghostMode]);

    const currentId = AppUtils.createHighlightId(horizontalPosition, verticalPosition);
    const isActive = id === currentId;
    const isGhostHighlightActive = ghostMode && isActive;
    const isHighlightVisible = !(isAnyGuideOverlayVisible || isSpinnerActive);

    return (
        <Highlight
            cellType={cellType}
            isActive={isActive}
            isGhostHighlightActive={isGhostHighlightActive}
            isHighlightVisible={isHighlightVisible || ghostMode}
            isPastGuideMode={false}
        />
    );
};
